// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__x5smS","separator":"styles_separator__Wuf8B","prev":"styles_prev__5rB-s","next":"styles_next__+3H6W","disabled":"styles_disabled__fr1Dt"};